import { env } from '../../config/env';
import type {
  IyzicoCompleteRequest,
  IyzicoCompleteResponse,
  IyzicoInitiateRequest,
  IyzicoInitializeResponse,
} from '../../types/payment';
import * as http from './paymentService.http';
import * as mock from './paymentService.mock';

export interface PaymentService {
  initializeIyzico(payload: IyzicoInitiateRequest): Promise<IyzicoInitializeResponse>;
  completeIyzico(payload: IyzicoCompleteRequest): Promise<IyzicoCompleteResponse>;
}

const mockPaymentService: PaymentService = {
  initializeIyzico: mock.mockInitializeIyzico,
  completeIyzico: mock.mockCompleteIyzico,
};

const httpPaymentService: PaymentService = {
  initializeIyzico: http.httpInitializeIyzico,
  completeIyzico: http.httpCompleteIyzico,
};

export const paymentService: PaymentService = env.useMock ? mockPaymentService : httpPaymentService;
